import { createApp } from 'vue'
import __t from "../../../../helpers/translate";
import vue_helpers from "../../../../helpers/check_null";
import {createBootstrap} from 'bootstrap-vue-next';
import fmtDate from "../../../../helpers/fmtDay";

import users_table from "./users_table.vue";

window.U_LIST = createApp({
    name : "U_LIST",
    id : "U_LIST",
    components : {
        users_table : users_table,
    }
})
    .mixin(fmtDate)
    .mixin(__t)
    .mixin(vue_helpers)
    .use(createBootstrap())
    .use(v_store);

U_LIST.mount('#users');